// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Swiper from 'swiper/js/swiper';

const fragments = {
	SWIPER: '[data-fragment="NewsItemSlider.swiper"]',
	PREV: '[data-fragment="NewsItemSlider.prev"]',
	NEXT: '[data-fragment="NewsItemSlider.next"]',
	PAGINATION: '[data-fragment="NewsItemSlider.pagination"]',
};

export default class NewsItemSlider extends WebComponent {
	constructor (props) {
		super(props);
	}

	didMount() {
		this.swiperElement = this.element.querySelector(fragments.SWIPER);
		this.swipers = new Swiper(this.swiperElement, {
			slidesPerView: 1,
			navigation: {
				nextEl: fragments.NEXT,
				prevEl: fragments.PREV,
			},
			pagination: {
				el: fragments.PAGINATION,
				clickable: true,
			},
		});
	}
	willUnMount() {}
	update() {}
}



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/components/NewsItemSlider.js